import AppRestService from './app-rest.service';
import AuthService from './auth.service';
import ComingSoonService from './coming-soon.service'
import ImdbSerivce from './imdb.service';
import MoviesService from './movies.service';
import NewsService from './news.service';
import PublishService from './publish.service';
import SchedulesService from './schedules.service';
import TheatersService from './theaters.service';
import UsersService from './users.service';


export default {
  AppRestService,
  AuthService,
  ComingSoonService,
  ImdbSerivce,
  MoviesService,
  NewsService,
  PublishService,
  SchedulesService,
  TheatersService,
  UsersService,
};

